import React, { useEffect } from 'react';
import './refundpolicy.css'; // Importing the separate CSS file
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Footer from '../Components/Footer';

export default function RefundPolicy() {

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);


  return (
    <>
      
      
      <div className="refund-policy-container">
      <button>
  <Link to="/" style={{ color: "white", textDecoration: "none" }}>Home</Link>
</button>


        <h1>Refund Policy</h1>
        <p>
          At <strong>Appollo Agency</strong>, customer satisfaction is our priority. We strive to provide the best insurance services. However, we understand that there may be situations where a refund is required. Please read our refund policy carefully.
        </p>

        <h2>1. Eligibility for Refund</h2>
        <p>Refunds are applicable under the following conditions:</p>
        <ul>
          <li>If the insurance policy is canceled within the free-look period as per the insurer's terms.</li>
          <li>If payment was made due to a technical error (e.g., duplicate transaction).</li>
          <li>If the service was not provided as per the agreed terms.</li>
        </ul>

        <h2>2. Non-Refundable Cases</h2>
        <p>Refunds will not be processed in the following cases:</p>
        <ul>
          <li>After the policy has been issued and the free-look period has expired.</li>
          <li>If a claim has been made on the policy.</li>
          <li>If incorrect information was provided during policy registration.</li>
        </ul>

        <h2>3. Refund Process</h2>
        <p>If you are eligible for a refund, follow these steps:</p>
        <ul>
          <li>Contact our customer support team at <strong>info.appolloagency@gmail.com</strong> within given days of payment.</li>
          <li>Provide proof of transaction and the reason for the refund request.</li>
          <li>Once approved, refunds will be processed within 10-20 business days.</li>
        </ul>

        <h2>4. Contact Us</h2>
        <p>If you have any questions about our refund policy, please reach out to us at:</p>
        <p><strong>Email:</strong> info.appolloagency@gmail.com</p>
        <p><strong>Phone:</strong> +919884226561</p>
      </div>

      <Footer />
    </>
  );
}
